import React, { Fragment } from 'react';
import cx from 'classnames';

import styles from './cartHeader.module.less';
import mixinStyles from '../stylesheets/mixins.module.less';

export const CartHeader = () => {
  return (
    <Fragment>
      <div className={cx(styles.cartGridHeader, styles.cartGridHeaderItemLabel)}>Item</div>
      <div className={cx(styles.cartGridHeader, mixinStyles.alignRight)}>Unit price</div>
      <div className={cx(styles.cartGridHeader, mixinStyles.alignCenter)}>Quantity</div>
      <div className={cx(styles.cartGridHeader, mixinStyles.alignRight)}>Subtotal</div>
    </Fragment>
  );
};
